import {
  TableCell,
  TableRow,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";

interface Props {
  colSpan: number;
  message: string;
  type?: "loading" | "error";
}

export const StatusRow = ({ colSpan, message, type = "loading" }: Props) => (
  <TableRow>
    <TableCell colSpan={colSpan} sx={{ border: "none !important" }}>
      {type === "loading" ? (
        <>
          <LinearProgress color="primary" />
          <Stack padding={2}>
            <Typography variant="subtitle2">{message}</Typography>
          </Stack>
        </>
      ) : (
        <Stack padding={2} direction="row" alignItems="center" gap={1}>
          <ErrorIcon color="error" />
          <Typography variant="subtitle2">{message}</Typography>
        </Stack>
      )}
    </TableCell>
  </TableRow>
);
